<app-breadcrumb [breadcrumbs]="breadcrumbs$ | async"></app-breadcrumb>

<app-iframe [src]="url$ | async"
            [width]="'1200px'"
></app-iframe>
